import {
    VIEW_CANDIDATELIST_REQUEST,
    VIEW_CANDIDATELIST_SUCCESS,
    VIEW_CANDIDATELIST_FAIL
  } from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

const baseUrl = process.env.REACT_APP_API_PATH

export const CandidatePageAction=  (data) => {
    return function (dispatch) {
      
      dispatch({
        type: VIEW_CANDIDATELIST_REQUEST,
        payload: true,
      });
  
      let OPTION = {
        // http://ebench-env.eba-tckyjspw.ap-south-1.elasticbeanstalk.com/ebench
        url: `${baseUrl}/ebench/get_all_candidate_v2`,
        method: "POST",
        data: data,
        headers: {
          "content-type": "application/json",
        },
      };
        axios(OPTION)
        .then((res) => {
          dispatch(GetCandidateData(res.data));
          //  localStorage.setItem("userInfo", JSON.stringify(res.data));
          //   window.location.href = "/";
        })
        .catch((error) => {
          dispatch({
            type: VIEW_CANDIDATELIST_FAIL,
            payload: false,
            error: error,
            createJob: error.success,
            msg: "Failed to create user registration",
          });
          toast.error(error.msg);
        });
    };
  };


   
  export const GetCandidateData = (data) => {
    // toast.success("Added Successfully.");
    // setTimeout(()=>{
    //     window.location.href = "/candidate_dashboard";
    //  },2000)
    return {
      type: VIEW_CANDIDATELIST_SUCCESS,
      createJob: data.status.message,
      result: data,
      payload: false,
      msg: data.status.message,
    };
  };


// import {
//     VIEW_CANDIDATELIST_REQUEST,
//     VIEW_CANDIDATELIST_SUCCESS,
//     VIEW_CANDIDATELIST_FAIL
//   } from "../constants/AuthConstant";
  
//   import axios from "axios";
//   import { toast } from "react-toastify";
  
//   const baseUrl = process.env.REACT_APP_API_PATH;
  
//   export const CandidatePageAction = (data) => {
//     return async (dispatch) => {
//       dispatch({
//         type: VIEW_CANDIDATELIST_REQUEST,
//         payload: true,
//       });
  
//       try {
//         const response = await axios.post(`${baseUrl}/get_all_candidate_v2`, data);
//         dispatch(GetCandidateData(response.data));
//       } catch (error) {
//         const errorMessage = error.response && error.response.data.message
//           ? error.response.data.message
//           : error.message;
  
//         dispatch({
//           type: VIEW_CANDIDATELIST_FAIL,
//           payload: false,
//           error: errorMessage,
//           createJob: false,
//           msg: "Failed to fetch candidate list",
//         });
  
//         toast.error(errorMessage);
//       }
//     };
//   };
  
//   export const GetCandidateData = (data) => {
//     toast.success("Added Successfully.");
    
//     return {
//       type: VIEW_CANDIDATELIST_SUCCESS,
//       createJob: data.status.message,
//       result: data,
//       payload: false,
//       msg: data.status.message,
//     };
//   };
  